import { PRIMARY_KEYS } from "src/pages/ad-studio/insights/performance/view/constants";
import { PerformanceViewPrimitive } from "src/pages/ad-studio/insights/performance/view/performance-view-primitive";
import type {
  Kind,
  Page,
  RowOf,
  SortedColumn,
} from "src/pages/ad-studio/insights/performance/view/types";

type ListTableProps<K extends Kind> = {
  page: Page<K>;
  performAction: (action: SortedColumn) => void;
};

/** A page of a list whose rows only show their cells. */
export const ListTable = <K extends Kind>({
  page,
  performAction,
}: ListTableProps<K>) => (
  <PerformanceViewPrimitive.Table<RowOf<K>>
    rows={page.list.rows}
    columns={page.columns}
    primaryKey={PRIMARY_KEYS[page.kind]}
    empty={page.empty}
    performAction={performAction}
  />
);
